<template>
	<a rel="sponsored" class="flex flex-column items-center block overflow-hidden hover:bg-gray-100"
	   :class="{'border rounded': props.outlined}"
	   :href="`https://www.awin1.com/cread.php?${props.queryId}`">
		<img :src="`https://www.awin1.com/cshow.php?${props.queryId}`" border="0" class="max-w-full">
		<span class="text-2xs text-gray-400 p-2">{{ $t('label.ad') }}</span>
	</a>
</template>

<script setup lang="ts">
const props = defineProps<{
	// The full query param string of the ad, e.g, "s=2379396&v=11417&q=332767&r=555993"
	queryId: string,

	outlined?: boolean
}>();

</script>